module.exports = __webpack_public_path__ + "img/Bouclier03.44f4ece3.png";